import React from 'react'

export default function Credit() {
  return (
    <div className='credit'>by: Sergio</div>
  )
}
